import React, { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

/**
 * Magazine-style interior poses.
 * Distance from target must stay ≤ OrbitControls maxDistance (0.51).
 */
export const CAMERA_PRESETS = {

  hero: {

    label: 'Общий',
    position: [ 0, 0.02, -0.48 ],
    target: [ 0, 0.06, 0.02 ],

  },

  window: {

    label: 'К окну',
    position: [ 0.1, 0.16, -0.38 ],
    target: [ 0.04, 0.28, 0.12 ],

  },

  corner: {

    label: 'Угол',
    position: [ -0.28, 0.06, -0.36 ],
    target: [ 0.12, -0.04, 0.08 ],

  },

  floor: {

    label: 'Пол',
    position: [ 0.06, -0.28, -0.36 ],
    target: [ 0.04, -0.52, 0.05 ],

  },

}

/**
 * Exposes snapToPreset(id) via apiRef for UI outside the Canvas.
 */
export function CameraDirector({ apiRef, controlsRef }) {

  const { camera } = useThree();

  useEffect(() => {

    if ( !apiRef ) return;

    apiRef.current = {

      snapToPreset: ( id ) => {

        const preset = CAMERA_PRESETS[ id ];
        if ( !preset ) return;

        const target = new THREE.Vector3( ...preset.target );
        const position = new THREE.Vector3( ...preset.position );
        const controls = controlsRef?.current;
        const maxDist = controls?.maxDistance ?? 0.51;

        // Keep within OrbitControls dolly limit so damping won't yank the camera back
        const offset = position.clone().sub( target );
        const dist = offset.length();

        if ( dist > maxDist && dist > 1e-4 ) {

          offset.multiplyScalar( maxDist / dist );
          position.copy( target ).add( offset );

        }

        camera.position.copy( position );

        if ( controls ) {

          controls.target.copy( target );
          controls.update();

        } else {

          camera.lookAt( target );

        }

      },

    };

    return () => {

      if ( apiRef ) apiRef.current = null;

    };

  }, [ apiRef, controlsRef, camera ]);

  return null;

}
